export default "__VITE_ASSET__CDpSsKo6__"